import React, { useState, useEffect } from 'react';
import { ShoppingBag, Menu, X } from 'lucide-react';

const Navbar = ({ cartCount, onCartOpen }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileOpen(false);
  };

  const navLinks = [
    { label: 'Nuestras Croquetas', id: 'catalogo' },
    { label: 'La Galería', id: 'galeria' },
    { label: 'El Manifiesto', id: 'manifiesto' },
    { label: 'Profesionales', id: 'b2b' },
    { label: 'FAQ', id: 'faq' },
  ];

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'backdrop-blur-xl bg-[#F5F0E8]/90 border-b border-[#D4A853]/20 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <button
            data-testid="logo-button"
            onClick={() => scrollTo('hero')}
            className="text-left leading-none"
          >
            <div className={`font-serif font-bold tracking-[0.18em] text-sm md:text-base uppercase transition-colors duration-300 ${scrolled ? 'text-[#7B1F3A]' : 'text-white'}`}>
              Las Croquetas
            </div>
            <div
              className={`font-serif text-xs md:text-sm tracking-[0.2em] text-center transition-colors duration-300 ${scrolled ? 'text-[#7B1F3A]' : 'text-white/80'}`}
              style={{ fontVariant: 'small-caps' }}
            >
              de María
            </div>
          </button>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map(({ label, id }) => (
              <button
                key={id}
                data-testid={`nav-${id}`}
                onClick={() => scrollTo(id)}
                className={`text-sm font-medium tracking-wide hover:text-[#D4A853] transition-colors duration-200 ${
                  scrolled ? 'text-[#2C2C2A]' : 'text-white'
                }`}
              >
                {label}
              </button>
            ))}
          </div>

          {/* Cart + Mobile Toggle */}
          <div className="flex items-center gap-2">
            <button
              data-testid="cart-icon-button"
              onClick={onCartOpen}
              aria-label="Abrir carrito"
              className={`relative p-2 transition-colors duration-200 ${
                scrolled ? 'text-[#2C2C2A]' : 'text-white'
              }`}
            >
              <ShoppingBag size={22} />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-[#7B1F3A] text-white text-xs w-5 h-5 flex items-center justify-center rounded-full font-bold">
                  {cartCount}
                </span>
              )}
            </button>
            <button
              data-testid="mobile-menu-toggle"
              className={`md:hidden p-2 transition-colors ${scrolled ? 'text-[#2C2C2A]' : 'text-white'}`}
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Menú"
            >
              {mobileOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#F5F0E8] border-t border-[#EBE5DB] px-4 py-2 shadow-lg"
        >
          {navLinks.map(({ label, id }) => (
            <button
              key={id}
              onClick={() => scrollTo(id)}
              className="block w-full text-left py-4 text-[#2C2C2A] font-medium text-sm border-b border-[#EBE5DB] last:border-0 hover:text-[#7B1F3A] transition-colors"
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
